'use client';
import {Carousel} from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ShortcutDialogFC} from "@/app/_dialogs/ShortcutDialog/ShortcutDialog";
import {FirstChargeGiftPackDialogFC} from "@/app/_dialogs/FirstChargeGiftPackDialog/FirstChargeGiftPackDialog";
import {SpecialGiftPackDialogFC} from "@/app/_dialogs/SpecialGiftPackDialog/SpecialGiftPackDialog";
import {useUser} from "@/app/context/UserContext";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectShopItems} from "@/app/(pages)/shopItemsSlice";
import {useEffect} from "react";
import {getPaymentItemsAsync} from "@/app/(pages)/paymentItemsAPI";
import "./Banner.css";
import UserMgr from "@/Core/UserMgr";

const images = [
    {
        id: 1,
        url: '/img/home/banner.webp'
    },
    {
        id: 2,
        url: '/img/home/banner2.webp'
    },
    {
        id: 3,
        url: '/img/home/banner3.webp'
    },
];

enum BannerType {
    AddDesktop = 1, //添加桌面
    SpecialGift, //特价礼包
    FirstRechargeGift, //首充礼包
}

const settings = {
    arrows: false,
    customPaging: (i: number) => (
        <div className="indicator">
            <div
                key={images[i].id}
                className="indicator_item"
            >
            </div>
        </div>
    ),
    autoplay: true,
    autoplaySpeed: 5000,
}

export default function banner() {
    const user = useUser();
    const dispatch = useAppDispatch();
    const shopItem = useAppSelector(selectShopItems);

    useEffect(() => {
        if (UserMgr.hasTokenOk(user.token)){
            if (shopItem.shopItemsData.length <= 0) {
                dispatch(getPaymentItemsAsync())
            }
        }
    }, [user.token]);

    const onBannerClick = (id: BannerType) => {
        if (id === BannerType.AddDesktop) {
            SDialogManagerFC.openDialog(ShortcutDialogFC);
        } else if (id === BannerType.FirstRechargeGift) {
            SDialogManagerFC.openDialog(FirstChargeGiftPackDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
                userId: user.userId,
                shopItemsStarterData: shopItem.shopItemsStarterData,
                dispatcher: dispatch,
            });
        } else if (id === BannerType.SpecialGift) {
            SDialogManagerFC.openDialog(SpecialGiftPackDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(FirstChargeGiftPackDialogFC),
                userId: user.userId,
                shopItemsSpecialData: shopItem.shopItemsSpecialData,
                dispatcher: dispatch,
            });
        }
    }

    return (
        <div className="banner">
            <div className="banner_main">
                <Carousel settings={{...settings}}>
                    {images.map(image =>
                        <div key={image.id} onClick={() => onBannerClick(image.id)}>
                            <img src={image.url} alt="" />
                        </div>
                    )}
                </Carousel>
            </div>

        </div>
    )
}
